import React from "react";

const Loader = ({ 
  message = "Loading...", 
  size = "large",
  variant = "primary" // primary (amber) or secondary (purple)
}) => {
  const sizeClasses = {
    small: "h-6 w-6",
    medium: "h-10 w-10",
    large: "h-16 w-16",
  };

  const colorClasses = {
    primary: "border-amber-600",
    secondary: "border-purple-600",
  };

  const bgColorClasses = {
    primary: "bg-amber-50",
    secondary: "bg-purple-50",
  };

  const textColorClasses = {
    primary: "text-amber-700",
    secondary: "text-purple-700",
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div
        className={`${sizeClasses[size]} ${colorClasses[variant]} border-4 border-t-transparent rounded-full animate-spin`}
      ></div>
      {message && (
        <p className={`mt-4 text-sm font-medium ${textColorClasses[variant]}`}>
          {message}
        </p>
      )}
    </div>
  );
};

// Full Screen Loader Overlay
export const FullScreenLoader = ({ 
  message = "Processing...", 
  variant = "primary",
  show = true,
  blurIntensity = "md" // sm, md, lg for 10%, 15%, 20% blur
}) => {
  if (!show) return null;

  const blurClasses = {
    sm: "backdrop-blur-[2px]", // ~10% blur
    md: "backdrop-blur-[3px]", // ~15% blur
    lg: "backdrop-blur-[4px]", // ~20% blur
  };

  const overlayOpacity = {
    sm: "bg-black/10", // 10% opacity
    md: "bg-black/15", // 15% opacity
    lg: "bg-black/20", // 20% opacity
  };

  const colorClasses = {
    primary: "border-amber-600",
    secondary: "border-purple-600",
  };

  const textColorClasses = {
    primary: "text-amber-700",
    secondary: "text-purple-700",
  };

  const spinnerColorClasses = {
    primary: "text-amber-600",
    secondary: "text-purple-600",
  };

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-center justify-center ${overlayOpacity[blurIntensity]} ${blurClasses[blurIntensity]} transition-all duration-300`}
      style={{ 
        backdropFilter: `blur(${blurIntensity === 'sm' ? '2px' : blurIntensity === 'md' ? '3px' : '4px'})`,
        WebkitBackdropFilter: `blur(${blurIntensity === 'sm' ? '2px' : blurIntensity === 'md' ? '3px' : '4px'})`
      }}
    >
      <div className="bg-white/95 rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4 border border-gray-200">
        <div className="flex flex-col items-center justify-center">
          <div
            className={`h-16 w-16 ${colorClasses[variant]} border-4 border-t-transparent rounded-full animate-spin`}
          ></div>
          {message && (
            <p className={`mt-6 text-base font-semibold ${textColorClasses[variant]}`}>
              {message}
            </p>
          )}
          <p className="mt-2 text-sm text-gray-600 text-center">
            Please wait while we process your request...
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loader;

